var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{attrs:{"type":"checkbox","disabled":true},domProps:{"checked":_vm.params.value}})
}
var staticRenderFns = []

export { render, staticRenderFns }